import { InputProps, InputRef } from 'antd'
import Password from 'antd/es/input/Password'
import { Icon } from 'shared/iconpack'
import clsx from 'shared/libs/clsx'

import { forwardRef } from 'react'

import { palette } from 'shared/config/styles/palette'

type Props = InputProps & {
  withPlaceholder?: boolean
}

const PasswordFiled = forwardRef<InputRef, Props>(
  (
    { className, withPlaceholder = true, placeholder, ...props }: Props,
    ref,
  ) => (
    <Password
      className={clsx(className)}
      ref={ref}
      placeholder={withPlaceholder ? placeholder : ''}
      iconRender={(visible) =>
        visible ? (
          <Icon
            name="eyeOutline"
            color={palette.gray}
            width={20}
            height={18}
          />
        ) : (
          <Icon
            name="eye"
            color={palette.gray}
            width={20}
            height={20}
          />
        )
      }
      {...props}
    />
  ),
)

export default PasswordFiled
